import JSZip from "jszip";

const norm = (p) => p.replace(/\\/g, "/").replace(/^\/+/, "");

// If everything sits inside one top-level folder (e.g. "MissionReady/..."), treat that folder as the bundle root.
const wrapperLength = (paths) => {
  const tops = new Set(paths.map((p) => p.split("/")[0]));
  if (tops.size !== 1 || paths.some((p) => !p.includes("/"))) return 0;
  return [...tops][0].length + 1;
};

export const readBundleContents = async (file) => {
  const zip = await JSZip.loadAsync(file);
  const all = Object.values(zip.files);
  const wrap = wrapperLength(all.map((e) => norm(e.name)));
  const entries = [];
  const dirs = new Set();
  all.forEach((e) => {
    const path = norm(e.name).slice(wrap);
    if (!path) return;
    const parts = path.replace(/\/$/, "").split("/");
    for (let i = 1; i < parts.length + (e.dir ? 1 : 0); i += 1) dirs.add(parts.slice(0, i).join("/").toLowerCase());
    if (!e.dir) entries.push({ path, size: e._data?.uncompressedSize ?? null });
  });
  entries.sort((a, b) => a.path.localeCompare(b.path));
  return { entries, dirs };
};

const toRegex = (pattern) => {
  const src = pattern.replace(/[.+^${}()|[\]]/g, "\\$&").replace(/\*\*/g, "\u0000").replace(/\*/g, "[^/]*").replace(/\?/g, "[^/]").replace(/\u0000/g, ".*");
  return new RegExp(`^${src}$`, "i");
};

export const findMissing = (patterns, { entries, dirs }) =>
  patterns.filter((raw) => {
    const p = norm(raw.trim());
    if (!p) return false;
    if (p.endsWith("/")) {
      const re = toRegex(p.slice(0, -1));
      return ![...dirs].some((d) => re.test(d));
    }
    const re = toRegex(p);
    return !entries.some((e) => re.test(e.path));
  });
